var map = {
	"./Angel.svg": 11288,
	"./Atlantic.svg": 57037,
	"./BCBG.png": 15145,
	"./Bigg.svg": 67400,
	"./Clinique.svg": 5313,
	"./ETRO.svg": 43187,
	"./Estee.png": 1151,
	"./FIdelity.svg": 84867,
	"./Napster.svg": 54762,
	"./Netcoins.svg": 91616,
	"./PWC.png": 79855,
	"./Salesforce.svg": 45788,
	"./WarnerRecords.png": 50264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54106;